import React from 'react';
import Modal from './Modal';
import './HowItWorksModal.css';

interface HowItWorksModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const HowItWorksModal: React.FC<HowItWorksModalProps> = ({ isOpen, onClose }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="How 2 Play"
      className="how-it-works-modal"
    >
      <div className="how-it-works-content">
        <div className="steps-container">
          <div className="step">
            <div className="step-number">1</div>
            <div className="step-content">
              <h3>Pick Your Racer</h3>
              <p>Choose which crypto you think will gain more % in 15 seconds</p>
              <p className="step-subtext">
                Bars show win history & % dominance
              </p>
            </div>
          </div>

          <div className="step">
            <div className="step-number">2</div>
            <div className="step-content">
              <h3>Win to Climb</h3>
              <p>Each win moves you up the ladder. Lose once and you're out</p>
              <p className="step-subtext">
                Real-time price data powered by Pyth Network
              </p>
            </div>
          </div>

          <div className="step">
            <div className="step-number">3</div>
            <div className="step-content">
              <h3>Cash Out or Risk It</h3>
              <p>Take your winnings anytime or keep racing for bigger multipliers</p>
            </div>
          </div>
        </div>

        <div className="example-section">
          <div className="example-card">
            <div className="example-text">
              Bet 0.05 SOL → Win 10 races → Win 50 SOL
            </div>
            <div className="ladder-visual">
              <span className="multiplier">1x</span> → <span className="multiplier">1.9x</span> → <span className="multiplier">3.6x</span> → <span className="multiplier">6.9x</span> → <span className="multiplier">13.1x</span> → ... → <span className="multiplier-final">1000x</span>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default HowItWorksModal;
